/* eslint-disable array-callback-return */
import React, { useState, useRef, useContext, useEffect } from "react"
import PropTypes from "prop-types"
import { Fieldset } from "primereact/fieldset"
import { Toast } from "primereact/toast"
import { Toolbar } from "primereact/toolbar"
import CustomToolBar from "../../../ToolBar/customToolbar"
import { confirmation } from "../../../types/dropDownTypes"
import {
  existsErrors,
  getAdditionalQuestions,
  showMessage,
  showQuestion,
  updateState,
  validateQuestions,
  formatMixedQuestions,
  filterAdditionalQuestions,
  checkDisplayConditional,
  checkConditionalRender,
} from "../../../utils/utils"
import { errorMessages } from "../../../types/messages"
import ServicesRow from "./ServicesRow"
import { GpraContext } from "../../../../../context/gpraContext"
import { endpoints } from "../../../../../config/gpraApiEndpoints"
import FormLabel from "../../../Common/FormLabel"
import FormError from "../../../Common/FormError"
import gpraStyles from "../../../../../styles/Participant-GPRA.module.css"
import { INTERVIEW_SECTIONS } from "../../../types/interviewTypes"
import { InputText } from "primereact/inputtext"
import AdditionalQuestionContainer from "../../Additional/AdditionalQuestionContainer"
import { UserContext } from "../../../../../context/userContext"
const Services4 = (props) => {
  const { showToolBar, disabled } = props

  const {
    handleSubmitPut,
    interview,
    handleLoadNext,
    handleLoadPrev,
    handlePlannedServices4Saved,
    handleSectionsCompleted,
    sectionsCompleted,
    questions,
    updateInterviewValues,
    additionalQuestions,
    sections,
    activeIndex,
    editMode,
  } = useContext(GpraContext)

  const userCtx = useContext(UserContext)

  const [plannedServices4, setPlannedServices4] = useState(
    interview[INTERVIEW_SECTIONS.PLANNED_SERVICES_4]
  )
  const [validationErrors, setValidationErrors] = useState({})
  const [mixedQuestions, setMixedQuestions] = useState([])

  useEffect(() => {
    if (mixedQuestions.length === 0) {
      let filteredQuestions = []
      let filteredAdditional = []
      if (questions) {
        filteredQuestions = questions.filter(
          (q) =>
            q.section === INTERVIEW_SECTIONS.PLANNED_SERVICES_4 &&
            !q.field.endsWith("section")
        )
      }
      if (additionalQuestions) {
        filteredAdditional = filterAdditionalQuestions(
          additionalQuestions,
          INTERVIEW_SECTIONS.PLANNED_SERVICES_4
        )
      }
      setMixedQuestions(
        formatMixedQuestions(filteredQuestions, filteredAdditional)
      )
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [questions, additionalQuestions])

  const toast = useRef(null)

  const saveData = (setNextForm, prevForm, setNavigationItem) => {
    updateInterviewValues(
      INTERVIEW_SECTIONS.PLANNED_SERVICES_4,
      plannedServices4
    )
    if (prevForm) {
      handleLoadPrev(true)
      setNextForm(sections[activeIndex - 1].section)
      setNavigationItem()
    } else {
      if (validForm()) {
        handleLoadNext(true)
        handleSubmitPut(endpoints.SAVE_SERVICES4_DATA, {
          GpraBServicesEs1: plannedServices4?.gpra_b_services_es_1,
          GpraBServicesEs2: plannedServices4?.gpra_b_services_es_2,
          GpraBServicesEs3: plannedServices4?.gpra_b_services_es_3,
          GpraBServicesEs4: plannedServices4?.gpra_b_services_es_4,
          GpraBServicesEs5: plannedServices4?.gpra_b_services_es_5,
          GpraBServicesEs6: plannedServices4?.gpra_b_services_es_6,
          GpraBServicesEs7: plannedServices4?.gpra_b_services_es_7,
          GpraBServicesEs7a: plannedServices4?.gpra_b_services_es_7a,
          GpraBServicesP2p1: plannedServices4?.gpra_b_services_p2p_1,
          GpraBServicesP2p2: plannedServices4?.gpra_b_services_p2p_2,
          GpraBServicesP2p3: plannedServices4?.gpra_b_services_p2p_3,
          GpraBServicesP2p4: plannedServices4?.gpra_b_services_p2p_4,
          GpraBServicesP2p5: plannedServices4?.gpra_b_services_p2p_5,
          GpraBServicesP2p6: plannedServices4?.gpra_b_services_p2p_6,
          GpraBServicesP2p7: plannedServices4?.gpra_b_services_p2p_7,
          GpraBServicesP2p8: plannedServices4?.gpra_b_services_p2p_8,
          GpraBServicesP2p9: plannedServices4?.gpra_b_services_p2p_9,
          GpraBServicesP2p9a: plannedServices4?.gpra_b_services_p2p_9a,
          GpraInterviewId:
            interview[INTERVIEW_SECTIONS.RECORD_MGMT].interview_id,
          GpraBServicesId: plannedServices4?.gpra_b_services_id,
          Additional: getAdditionalQuestions(plannedServices4),
          EditMode: editMode,
          EditedBy: userCtx.session?.user?.staff_id,
        }).then((response) => {
          if (response.status === 200 || response.status === 201) {
            handlePlannedServices4Saved(true)
            handleLoadNext(false)
            setNextForm(sections[activeIndex + 1].section)
            setNavigationItem()
            handleSectionsCompleted({
              ...sectionsCompleted,
              ...{ plannedServices4: true },
            })
          }
        })
      } else {
        handleLoadNext(false)
        showMessage(false, errorMessages.toastErrorDetail, toast)
      }
    }
  }

  const removeError = (key) => {
    validationErrors[key] = null
    setValidationErrors(validationErrors)
  }

  const validForm = () => {
    const errors = {}
    if (
      plannedServices4?.gpra_b_services_es_1 === undefined &&
      showQuestion(questions, "gpra_b_services_es_1")
    ) {
      errors.gpra_b_services_es_1 = errorMessages.requiredMessage
    }
    if (
      plannedServices4?.gpra_b_services_es_2 === undefined &&
      showQuestion(questions, "gpra_b_services_es_1")
    ) {
      errors.gpra_b_services_es_2 = errorMessages.requiredMessage
    }
    if (
      plannedServices4?.gpra_b_services_es_3 === undefined &&
      showQuestion(questions, "gpra_b_services_es_1")
    ) {
      errors.gpra_b_services_es_3 = errorMessages.requiredMessage
    }
    if (
      plannedServices4?.gpra_b_services_es_4 === undefined &&
      showQuestion(questions, "gpra_b_services_es_1")
    ) {
      errors.gpra_b_services_es_4 = errorMessages.requiredMessage
    }
    if (
      plannedServices4?.gpra_b_services_es_5 === undefined &&
      showQuestion(questions, "gpra_b_services_es_1")
    ) {
      errors.gpra_b_services_es_5 = errorMessages.requiredMessage
    }
    if (
      plannedServices4?.gpra_b_services_es_6 === undefined &&
      showQuestion(questions, "gpra_b_services_es_1")
    ) {
      errors.gpra_b_services_es_6 = errorMessages.requiredMessage
    }
    if (
      plannedServices4?.gpra_b_services_es_7 === undefined &&
      showQuestion(questions, "gpra_b_services_es_1")
    ) {
      errors.gpra_b_services_es_7 = errorMessages.requiredMessage
    } else if (
      plannedServices4?.gpra_b_services_es_7 &&
      showQuestion(questions, "gpra_b_services_es_1")
    ) {
      if (!plannedServices4?.gpra_b_services_es_7a) {
        errors.gpra_b_services_es_7a = errorMessages.requiredMessage
      }
    }
    if (
      plannedServices4?.gpra_b_services_p2p_1 === undefined &&
      showQuestion(questions, "gpra_b_services_p2p_1")
    ) {
      errors.gpra_b_services_p2p_1 = errorMessages.requiredMessage
    }
    if (
      plannedServices4?.gpra_b_services_p2p_2 === undefined &&
      showQuestion(questions, "gpra_b_services_p2p_1")
    ) {
      errors.gpra_b_services_p2p_2 = errorMessages.requiredMessage
    }
    if (
      plannedServices4?.gpra_b_services_p2p_3 === undefined &&
      showQuestion(questions, "gpra_b_services_p2p_1")
    ) {
      errors.gpra_b_services_p2p_3 = errorMessages.requiredMessage
    }
    if (
      plannedServices4?.gpra_b_services_p2p_4 === undefined &&
      showQuestion(questions, "gpra_b_services_p2p_1")
    ) {
      errors.gpra_b_services_p2p_4 = errorMessages.requiredMessage
    }
    if (
      plannedServices4?.gpra_b_services_p2p_5 === undefined &&
      showQuestion(questions, "gpra_b_services_p2p_1")
    ) {
      errors.gpra_b_services_p2p_5 = errorMessages.requiredMessage
    }
    if (
      plannedServices4?.gpra_b_services_p2p_6 === undefined &&
      showQuestion(questions, "gpra_b_services_p2p_1")
    ) {
      errors.gpra_b_services_p2p_6 = errorMessages.requiredMessage
    }
    if (
      plannedServices4?.gpra_b_services_p2p_7 === undefined &&
      showQuestion(questions, "gpra_b_services_p2p_1")
    ) {
      errors.gpra_b_services_p2p_7 = errorMessages.requiredMessage
    }
    if (
      plannedServices4?.gpra_b_services_p2p_8 === undefined &&
      showQuestion(questions, "gpra_b_services_p2p_1")
    ) {
      errors.gpra_b_services_p2p_8 = errorMessages.requiredMessage
    }
    if (
      plannedServices4?.gpra_b_services_p2p_9 === undefined &&
      showQuestion(questions, "gpra_b_services_p2p_1")
    ) {
      errors.gpra_b_services_p2p_9 = errorMessages.requiredMessage
    } else if (
      plannedServices4?.gpra_b_services_p2p_9 &&
      showQuestion(questions, "gpra_b_services_p2p_1")
    ) {
      if (!plannedServices4?.gpra_b_services_p2p_9a) {
        errors.gpra_b_services_p2p_9a = errorMessages.requiredMessage
      }
    }
    setValidationErrors(
      validateQuestions(
        plannedServices4,
        INTERVIEW_SECTIONS.PLANNED_SERVICES_4,
        additionalQuestions,
        errors,
        questions
      )
    )
    return existsErrors(errors)
  }

  const renderDefaultMain = (question) => {
    if (question.field === "gpra_b_services_es_1") {
      return (
        <>
          <div className={gpraStyles.formRow}>
            <FormLabel label={`${question.number}. Education Services`} />
          </div>
          <div className={gpraStyles.formServicesRow}>
            <ServicesRow
              entity={plannedServices4}
              setEntity={setPlannedServices4}
              showNumber={false}
              removeError={removeError}
              label={`1. Substance Abuse Education`}
              options={confirmation}
              drop={plannedServices4?.gpra_b_services_es_1}
              setDrop={"gpra_b_services_es_1"}
              dropError={validationErrors.gpra_b_services_es_1}
              summaryDisabled={disabled}
              required
            />
          </div>
          <div className={gpraStyles.formServicesRow}>
            <ServicesRow
              entity={plannedServices4}
              setEntity={setPlannedServices4}
              showNumber={false}
              removeError={removeError}
              label={`2. HIV/AIDS Education`}
              options={confirmation}
              drop={plannedServices4?.gpra_b_services_es_2}
              setDrop={"gpra_b_services_es_2"}
              dropError={validationErrors.gpra_b_services_es_2}
              summaryDisabled={disabled}
              required
            />
          </div>
          <div className={gpraStyles.formServicesRow}>
            <ServicesRow
              entity={plannedServices4}
              setEntity={setPlannedServices4}
              showNumber={false}
              removeError={removeError}
              label={`3. Naloxone Training`}
              options={confirmation}
              drop={plannedServices4?.gpra_b_services_es_3}
              setDrop={"gpra_b_services_es_3"}
              dropError={validationErrors.gpra_b_services_es_3}
              summaryDisabled={disabled}
              required
            />
          </div>
          <div className={gpraStyles.formServicesRow}>
            <ServicesRow
              entity={plannedServices4}
              setEntity={setPlannedServices4}
              showNumber={false}
              removeError={removeError}
              label={`4. Fentanyl Test Strip Training`}
              options={confirmation}
              drop={plannedServices4?.gpra_b_services_es_4}
              setDrop={"gpra_b_services_es_4"}
              dropError={validationErrors.gpra_b_services_es_4}
              summaryDisabled={disabled}
              required
            />
          </div>
          <div className={gpraStyles.formServicesRow}>
            <ServicesRow
              entity={plannedServices4}
              setEntity={setPlannedServices4}
              showNumber={false}
              removeError={removeError}
              label={`5. Viral Hepatitis Education`}
              options={confirmation}
              drop={plannedServices4?.gpra_b_services_es_5}
              setDrop={"gpra_b_services_es_5"}
              dropError={validationErrors.gpra_b_services_es_5}
              summaryDisabled={disabled}
              required
            />
          </div>
          <div className={gpraStyles.formServicesRow}>
            <ServicesRow
              entity={plannedServices4}
              setEntity={setPlannedServices4}
              showNumber={false}
              removeError={removeError}
              label={`6. Other STI Education Services`}
              options={confirmation}
              drop={plannedServices4?.gpra_b_services_es_6}
              setDrop={"gpra_b_services_es_6"}
              dropError={validationErrors.gpra_b_services_es_6}
              summaryDisabled={disabled}
              required
            />
          </div>
          <div className={gpraStyles.formServicesRow}>
            <ServicesRow
              entity={plannedServices4}
              setEntity={setPlannedServices4}
              showNumber={false}
              removeError={removeError}
              label={`7. Other Education Services (Specify)`}
              options={confirmation}
              drop={plannedServices4?.gpra_b_services_es_7}
              setDrop={"gpra_b_services_es_7"}
              dropError={validationErrors.gpra_b_services_es_7}
              extraValues={[{ key: "gpra_b_services_es_7a", value: "" }]}
              summaryDisabled={disabled}
              errorsToRemove={["gpra_b_services_es_7a"]}
              required
            />
          </div>
          {plannedServices4?.gpra_b_services_es_7 && (
            <div className={gpraStyles.formRow}>
              <InputText
                className={
                  validationErrors.gpra_b_services_es_7a
                    ? gpraStyles.inputText5Error
                    : gpraStyles.inputText5
                }
                disabled={!plannedServices4?.gpra_b_services_es_7 || disabled}
                placeholder={
                  !plannedServices4?.gpra_b_services_es_7
                    ? "Not Applicable"
                    : ""
                }
                value={plannedServices4?.gpra_b_services_es_7a}
                onChange={(e) => {
                  updateState(
                    "gpra_b_services_es_7a",
                    e.target.value,
                    null,
                    null,
                    plannedServices4,
                    setPlannedServices4,
                    null
                  )
                  removeError("gpra_b_services_es_7a")
                }}
              />
              <FormError error={validationErrors.gpra_b_services_es_7a} />
            </div>
          )}
        </>
      )
    }
    if (question.field === "gpra_b_services_p2p_1") {
      return (
        <>
          <div className={gpraStyles.formRow} style={{ marginBottom: "1rem" }}>
            <FormLabel
              label={`${question.number}. Peer-To-Peer Recovery Support Services`}
            />
          </div>
          <div className={gpraStyles.formServicesRow}>
            <ServicesRow
              entity={plannedServices4}
              setEntity={setPlannedServices4}
              showNumber={false}
              removeError={removeError}
              label={`1. Peer Coaching Or Mentoring`}
              options={confirmation}
              drop={plannedServices4?.gpra_b_services_p2p_1}
              setDrop={"gpra_b_services_p2p_1"}
              dropError={validationErrors.gpra_b_services_p2p_1}
              summaryDisabled={disabled}
              required
            />
          </div>
          <div className={gpraStyles.formServicesRow}>
            <ServicesRow
              entity={plannedServices4}
              setEntity={setPlannedServices4}
              showNumber={false}
              removeError={removeError}
              label={`2. Vocational Services`}
              options={confirmation}
              drop={plannedServices4?.gpra_b_services_p2p_2}
              setDrop={"gpra_b_services_p2p_2"}
              dropError={validationErrors.gpra_b_services_p2p_2}
              summaryDisabled={disabled}
              required
            />
          </div>
          <div className={gpraStyles.formServicesRow}>
            <ServicesRow
              entity={plannedServices4}
              setEntity={setPlannedServices4}
              showNumber={false}
              removeError={removeError}
              label={`3. Recovery Housing`}
              options={confirmation}
              drop={plannedServices4?.gpra_b_services_p2p_3}
              setDrop={"gpra_b_services_p2p_3"}
              dropError={validationErrors.gpra_b_services_p2p_3}
              summaryDisabled={disabled}
              required
            />
          </div>
          <div className={gpraStyles.formServicesRow}>
            <ServicesRow
              entity={plannedServices4}
              setEntity={setPlannedServices4}
              showNumber={false}
              removeError={removeError}
              label={`4. Recovery Planning`}
              options={confirmation}
              drop={plannedServices4?.gpra_b_services_p2p_4}
              setDrop={"gpra_b_services_p2p_4"}
              dropError={validationErrors.gpra_b_services_p2p_4}
              summaryDisabled={disabled}
              required
            />
          </div>
          <div className={gpraStyles.formServicesRow}>
            <ServicesRow
              entity={plannedServices4}
              setEntity={setPlannedServices4}
              showNumber={false}
              removeError={removeError}
              label={`5. Case Management Services to Specifically  Support Recovery`}
              options={confirmation}
              drop={plannedServices4?.gpra_b_services_p2p_5}
              setDrop={"gpra_b_services_p2p_5"}
              dropError={validationErrors.gpra_b_services_p2p_5}
              summaryDisabled={disabled}
              required
            />
          </div>
          <div className={gpraStyles.formServicesRow}>
            <ServicesRow
              entity={plannedServices4}
              setEntity={setPlannedServices4}
              showNumber={false}
              removeError={removeError}
              label={`6. Alcohol- and Drug-Free Social Activities`}
              options={confirmation}
              drop={plannedServices4?.gpra_b_services_p2p_6}
              setDrop={"gpra_b_services_p2p_6"}
              dropError={validationErrors.gpra_b_services_p2p_6}
              summaryDisabled={disabled}
              required
            />
          </div>
          <div className={gpraStyles.formServicesRow}>
            <ServicesRow
              entity={plannedServices4}
              setEntity={setPlannedServices4}
              showNumber={false}
              removeError={removeError}
              label={`7. Information and Referral`}
              options={confirmation}
              drop={plannedServices4?.gpra_b_services_p2p_7}
              setDrop={"gpra_b_services_p2p_7"}
              dropError={validationErrors.gpra_b_services_p2p_7}
              summaryDisabled={disabled}
              required
            />
          </div>
          <div className={gpraStyles.formServicesRow}>
            <ServicesRow
              entity={plannedServices4}
              setEntity={setPlannedServices4}
              showNumber={false}
              removeError={removeError}
              label={`8. Other Recovery Support Services`}
              options={confirmation}
              drop={plannedServices4?.gpra_b_services_p2p_8}
              setDrop={"gpra_b_services_p2p_8"}
              dropError={validationErrors.gpra_b_services_p2p_8}
              extraValues={[{ key: "gpra_b_services_p2p_8a", value: "" }]}
              summaryDisabled={disabled}
              errorsToRemove={["gpra_b_services_p2p_8a"]}
              required
            />
          </div>
          {plannedServices4?.gpra_b_services_p2p_8 && (
            <div className={gpraStyles.formServicesRow}>
              <InputText
                className={
                  validationErrors.gpra_b_services_p2p_8a
                    ? gpraStyles.inputText5Error
                    : gpraStyles.inputText5
                }
                disabled={!plannedServices4?.gpra_b_services_p2p_8 || disabled}
                placeholder={
                  !plannedServices4?.gpra_b_services_p2p_8
                    ? "Not Applicable"
                    : ""
                }
                value={plannedServices4?.gpra_b_services_p2p_8a}
                onChange={(e) => {
                  updateState(
                    "gpra_b_services_p2p_8a",
                    e.target.value,
                    null,
                    null,
                    plannedServices4,
                    setPlannedServices4,
                    null
                  )
                  removeError("gpra_b_services_p2p_8a")
                }}
              />
              <FormError
                error={validationErrors.gpra_b_services_p2p_8a}
                errorType={2}
              />
            </div>
          )}
          <div className={gpraStyles.formServicesRow}>
            <ServicesRow
              entity={plannedServices4}
              setEntity={setPlannedServices4}
              showNumber={false}
              removeError={removeError}
              label={`9. Other Peer-to-Peer Recovery Support Services`}
              options={confirmation}
              drop={plannedServices4?.gpra_b_services_p2p_9}
              setDrop={"gpra_b_services_p2p_9"}
              dropError={validationErrors.gpra_b_services_p2p_9}
              extraValues={[{ key: "gpra_b_services_p2p_9a", value: "" }]}
              summaryDisabled={disabled}
              errorsToRemove={["gpra_b_services_p2p_9a"]}
              required
            />
          </div>
          {plannedServices4?.gpra_b_services_p2p_9 && (
            <div className={gpraStyles.formServicesRow}>
              <InputText
                className={
                  validationErrors.gpra_b_services_p2p_9a
                    ? gpraStyles.inputText5Error
                    : gpraStyles.inputText5
                }
                disabled={!plannedServices4?.gpra_b_services_p2p_9 || disabled}
                placeholder={
                  !plannedServices4?.gpra_b_services_p2p_9
                    ? "Not Applicable"
                    : ""
                }
                value={plannedServices4?.gpra_b_services_p2p_9a}
                onChange={(e) => {
                  updateState(
                    "gpra_b_services_p2p_9a",
                    e.target.value,
                    null,
                    null,
                    plannedServices4,
                    setPlannedServices4,
                    null
                  )
                  removeError("gpra_b_services_p2p_9a")
                }}
              />
              <FormError error={validationErrors.gpra_b_services_p2p_9a} />
            </div>
          )}
        </>
      )
    }
  }
  return (
    <div>
      <Toast ref={toast} />
      {showToolBar && (
        <Toolbar
          className={gpraStyles.mb2}
          right={
            <CustomToolBar
              prevForm={true}
              nextForm={true}
              saveData={saveData}
              toast={toast}
            />
          }
        ></Toolbar>
      )}
      <Fieldset
        legend="B. SUBSTANCE USE AND PLANNED SERVICES"
        style={{ marginBottom: "1rem" }}
      >
        <div className={gpraStyles.grid}>
          {mixedQuestions?.map((question) => {
            if (question.kind === "default") {
              if (question.show) {
                return renderDefaultMain(question)
              }
            } else {
              if (
                checkConditionalRender(
                  question.enabled,
                  question.required,
                  question.kind,
                  question.conditionalSource
                )
              ) {
                return (
                  <AdditionalQuestionContainer
                    entity={plannedServices4}
                    setEntity={setPlannedServices4}
                    errors={validationErrors}
                    section={INTERVIEW_SECTIONS.PLANNED_SERVICES_4}
                    removeError={removeError}
                    disabled={disabled}
                    question={question.question}
                    number={question.number}
                    kind={question.kind}
                  />
                )
              } else {
                if (checkDisplayConditional(question, plannedServices4)) {
                  return (
                    <AdditionalQuestionContainer
                      entity={plannedServices4}
                      setEntity={setPlannedServices4}
                      errors={validationErrors}
                      section={INTERVIEW_SECTIONS.PLANNED_SERVICES_4}
                      removeError={removeError}
                      disabled={disabled}
                      question={question.question}
                      number={question.number}
                      kind={question.kind}
                    />
                  )
                }
              }
            }
          })}
        </div>
      </Fieldset>
      {showToolBar && (
        <Toolbar
          className={gpraStyles.mt2}
          right={
            <CustomToolBar
              prevForm={true}
              nextForm={true}
              saveData={saveData}
              toast={toast}
            />
          }
        ></Toolbar>
      )}
    </div>
  )
}

Services4.propTypes = {
  showToolBar: PropTypes.bool,
  disabled: PropTypes.bool,
}

Services4.defaultProps = {
  showToolBar: true,
  disabled: false,
}

export default Services4
